import { useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Button, TextField, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link, RouteComponentProps } from "react-router-dom";
import { useTenantService } from "../tenants/tenantService";
import { IntegrationsList } from "./IntegrationsList";

export default function IntegrationsPage(props: RouteComponentProps) {
  const tenantService = useTenantService();
  const [tenants, setTenants] = useState<any[]>([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    tenantService.getAll().then(setTenants);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredTenants = tenants.filter((t) =>
    t.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <Link style={{ textDecoration: "none" }} to="/create-integration">
        <Button variant="contained">Ny integrasjon</Button>
      </Link>
      <TextField
        label="Søk tenant"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        fullWidth
        sx={{ mt: 2, mb: 2 }}
      />
      {filteredTenants.map((tenant) => (
        <Accordion key={tenant.id} TransitionProps={{ mountOnEnter: true, unmountOnExit: false }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>{tenant.name}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <IntegrationsList tenantId={tenant.id} />
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
}
